module.exports = __webpack_public_path__ + "media/images/footer/impact_local-7c1ac61ac62b610caea703d4fb2a915c.svg";